<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>{{ $t("visabigtitle") }}</span>
      </div>
      <div class="small-title">{{ $t("visabigtitle1") }}</div>
      <div class="text">
        {{ $t("visatext1") }}
        <!-- Please send the request to the following email:
				<span class="email">ids2024@jiangnan.edu.cn</span> -->
        <span class="email cup" @click="download(1)">
          {{ $t("visatext2") }}</span
        >
        {{ $t("visatext3") }}
        <span class="email cup" @click="toRegFn"> {{ $t("visatext4") }}</span>
        {{ $t("visatext5") }}
      </div>
      <div class="text">{{ $t("visatext6") }}</div>

      <div class="small-title mt-30">{{ $t("visatext7") }}</div>
      <div class="text text-1">{{ $t("visatext8") }}</div>
      <div class="text text-1">{{ $t("visatext9") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toRegFn() {
      this.$router.push("/loginThen");
    },
    download() {
      let href =
        "https://www.ids2024.com/public/uploads/down/Invitation%20Letter%20Template%20(For%20Visa,%20IDS2024).docx";
      var a = document.createElement("a");
      a.href = href;
      a.download = `Abstract_Template_IDS2024.docx`;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
  },
};
</script>

<style scoped>

.index-con {
  margin: 0 auto;
  width: 1200px;
}
.email {
  color: rgb(30, 98, 222);
  font-weight: 600;
}

.title {
  color: #0a9a7a;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

.title::after {
  content: "";
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  width: 30px;
  height: 4px;
  text-align: center;
  background: #0a9a7a;
  position: absolute;
  margin-bottom: -10px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}

.text {
  color: #333;
  text-indent: 2em;
  line-height: 2;
  padding-bottom: 20px;
}
.text-1 {
  text-indent: 0;
  padding-left: 2em;
  position: relative;
}
.text-1::after {
  content: "";
  left: 0;
  top: 8px;
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #333;
}
.w-350 {
  width: 350px;
  margin: 0 auto;
  text-indent: 0;
  text-align: center;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}
.mt-30 {
  margin-top: 30px;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/visa.vue